<template>
  <div class="energy-overview">
    <!-- 顶部统计卡片：今日/昨日、本周/上周、本月/上月 三组 -->
    <div class="stat-cards">
      <div class="stat-card-group">
        <div class="stat-card-main">
          <span class="stat-label">今日用电</span>
          <span class="stat-value">{{ numFmt(powerdata.todayEnergy) }}</span>
          <span class="stat-unit">kwh</span>
        </div>
        <div class="stat-card-sub">
          <div class="sub-row">
            <span class="sub-label">昨日</span>
            <span class="sub-value">{{ numFmt(powerdata.yesterdayEnergy) }}</span>
            <span class="sub-unit">kwh</span>
          </div>
          <div class="sub-row" v-if="powerdata.yesterdaySamePeriodRingRatio != null">
            <span class="sub-compare" :class="compareTrendClass(powerdata.yesterdaySamePeriodRingRatio)">
              <img v-if="compareTrendIcon(powerdata.yesterdaySamePeriodRingRatio)" class="trend-arrow" :src="compareTrendIcon(powerdata.yesterdaySamePeriodRingRatio)" alt="">
              {{ powerdata.yesterdaySamePeriodRingRatio }}%
            </span>
            <span class="sub-label">环比</span>
          </div>
        </div>
      </div>
      <div class="stat-divider"></div>
      <div class="stat-card-group">
        <div class="stat-card-main">
          <span class="stat-label">本周用电</span>
          <span class="stat-value">{{ numFmt(powerdata.thisWeekEnergy) }}</span>
          <span class="stat-unit">kwh</span>
        </div>
        <div class="stat-card-sub">
          <div class="sub-row">
            <span class="sub-label">上周</span>
            <span class="sub-value">{{ numFmt(powerdata.oneBeforeWeekEnergy) }}</span>
            <span class="sub-unit">kwh</span>
          </div>
          <div class="sub-row" v-if="powerdata.oneBeforeWeekSamePeriodRingRatio != null">
            <span class="sub-compare" :class="compareTrendClass(powerdata.oneBeforeWeekSamePeriodRingRatio)">
              <img v-if="compareTrendIcon(powerdata.oneBeforeWeekSamePeriodRingRatio)" class="trend-arrow" :src="compareTrendIcon(powerdata.oneBeforeWeekSamePeriodRingRatio)" alt="">
              {{ powerdata.oneBeforeWeekSamePeriodRingRatio }}%
            </span>
            <span class="sub-label">环比</span>
          </div>
        </div>
      </div>
      <div class="stat-divider"></div>
      <div class="stat-card-group">
        <div class="stat-card-main">
          <span class="stat-label">本月用电</span>
          <span class="stat-value">{{ numFmt(powerdata.thisMonthEnergy) }}</span>
          <span class="stat-unit">kwh</span>
        </div>
        <div class="stat-card-sub">
          <div class="sub-row">
            <span class="sub-label">上月</span>
            <span class="sub-value">{{ numFmt(powerdata.oneBeforeMonthEnergy) }}</span>
            <span class="sub-unit">kwh</span>
          </div>
          <div class="sub-row" v-if="powerdata.oneBeforeMonthSamePeriodRingRatio != null">
            <span class="sub-compare" :class="compareTrendClass(powerdata.oneBeforeMonthSamePeriodRingRatio)">
              <img v-if="compareTrendIcon(powerdata.oneBeforeMonthSamePeriodRingRatio)" class="trend-arrow" :src="compareTrendIcon(powerdata.oneBeforeMonthSamePeriodRingRatio)" alt="">
              {{ powerdata.oneBeforeMonthSamePeriodRingRatio }}%
            </span>
            <span class="sub-label">环比</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 用电趋势 -->
    <div class="chart-card">
      <div class="chart-header">
        <span class="chart-title">用电趋势</span>
        <div class="chart-tabs">
          <div
            v-for="item in trendTabs"
            :key="item.value"
            class="tab-btn"
            :class="{ 'tab-active': isrisk === item.value }"
            @click="changerisk(item.value)">
            {{ item.label }}
          </div>
        </div>
        <div class="chart-actions">
          <el-date-picker
            v-if="isrisk === 'year'"
            v-model="year"
            value-format="yyyy"
            type="year"
            class="ov-date-picker"
          />
          <el-date-picker
            v-model="month"
            v-if="isrisk === 'month'"
            value-format="yyyy-MM"
            type="month"
            class="ov-date-picker"
          />
          <el-date-picker
            v-model="time"
            v-if="isrisk === 'day'"
            value-format="yyyy-MM-dd"
            type="date"
            class="ov-date-picker"
          />
          <el-button size="small" type="primary" @click="searchdata()">查询</el-button>
        </div>
      </div>
      <div class="chart-body">
        <div class="cav-chart" id="trendCav"></div>
      </div>
    </div>
  </div>
</template>

<script>
import Axios from "@/utils/Axios";
import { numFmt } from "@/utils/fmt";

export default {
  name: "SiteEnergyOverview",
  data() {
    return {
      powerdata:{
        oneBeforeMonthSamePeriodEnergy: null,
        oneBeforeMonthSamePeriodRingRatio: null,
        oneBeforeWeekSamePeriodEnergy: null,
        oneBeforeWeekSamePeriodRingRatio: null,
        thisMonthEnergy: null,
        thisWeekEnergy: null,
        todayEnergy: null,
        yesterdayEnergy: null,
        yesterdaySamePeriodEnergy: null,
        yesterdaySamePeriodRingRatio: null,
      },
      isrisk: "day",
      time: "",
      month: "",
      year: "",
      trendTabs: [
        { label: '日', value: 'day' },
        { label: '月', value: 'month' },
        { label: '年', value: 'year' }
      ],
    };
  },
  mounted() {
    this.saveid = sessionStorage.getItem('saveid');
    this.getNowTime();
    this.getpowerdata();
    this.searchdata();
  },
  methods: {
    numFmt,
    compareTrendClass(ratio) {
      const r = parseFloat(ratio);
      if (isNaN(r) || r === 0) return '';
      return r > 0 ? 'trend-up' : 'trend-down';
    },
    compareTrendIcon(ratio) {
      const r = parseFloat(ratio);
      if (isNaN(r) || r === 0) return '';
      return r > 0
        ? require('../../../assets/station/up.webp')
        : require('../../../assets/station/down.webp');
    },
    getNowTime() {
      var now = new Date();
      var year = now.getFullYear().toString();
      var month = now.getMonth() + 1;
      var date = now.getDate();
      if (month < 10) month = "0" + month;
      if (date < 10) date = "0" + date;
      this.time = year + "-" + month + "-" + date;
      this.month = year + "-" + month;
      this.year = year;
    },
    searchdata(){
      let param = {};
      if (this.isrisk === 'day') {
        param.url = "/energy/monitorHourEnergyTrend";
        param.data = { localDate: this.time, monitorSiteId: this.saveid };
      } else if (this.isrisk === 'month') {
        param.url = "/energy/monitorDayEnergyTrend";
        param.data = { yearMonth: this.month, monitorSiteId: this.saveid };
      } else if (this.isrisk === 'year') {
        param.url = "/energy/monitorMonthEnergyTrend";
        param.data = { year: this.year, monitorSiteId: this.saveid };
      }
      param.method = "post";
      Axios.ajax(param).then((res) => {
        if (res.data) {
          this.enerydata = res.data;
          this.getchart2(res.data);
        }
      });
    },
    getchart2(data){
      let xdata = [];
      let ydata = [];
      let ydata2 = [];
      for (let i = 0; i < data.length; i++) {
        xdata.push(data[i].dataTime);
        ydata.push(data[i].energy);
        ydata2.push(data[i].lastPeriodEnergy);
      }
      let myChart = this.$echarts.init(document.getElementById('trendCav'));
      let option = {
        tooltip: { trigger: 'axis' },
        grid: {
          right: 16,
          left: 56,
          top: 16,
          bottom: 24,
          containLabel: false
        },
        xAxis: [{
          type: 'category',
          data: xdata,
          axisLine: { lineStyle: { color: '#E4E7ED' } },
          axisTick: { show: false },
          axisLabel: { color: '#7D879F', fontSize: 12 }
        }],
        yAxis: [{
          type: 'value',
          position: 'left',
          axisLine: { lineStyle: { color: '#E4E7ED' } },
          splitLine: { lineStyle: { color: '#f0f0f0' } },
          axisLabel: { color: '#7D879F', fontSize: 12 }
        }],
        series: [
          {
            name: "能耗",
            type: "line",
            smooth: true,
            showAllSymbol: true,
            symbol: "circle",
            symbolSize: 4,
            itemStyle: { color: "#2A62FF" },
            lineStyle: { color: "#2A62FF", width: 4 },
            data: ydata
          },
          {
            name: "同期能耗",
            type: "line",
            smooth: true,
            showAllSymbol: true,
            symbol: "circle",
            symbolSize: 4,
            itemStyle: { color: "rgba(47, 194, 91, 1)" },
            lineStyle: { color: "rgba(47, 194, 91, 1)", width: 4 },
            data: ydata2
          }
        ]
      };
      myChart.setOption(option, true);
      window.onresize = myChart.resize;
    },
    getpowerdata(){
      let param = {};
      param.method = "post";
      param.url = "/energy/monitorEnergyTotal";
      param.data = { monitorSiteId: this.saveid };
      Axios.ajax(param).then((res) => {
        if (res.data) {
          this.powerdata = res.data;
        }
      });
    },
    changerisk(data){
      this.isrisk = data;
      if (data === 'year') {
        this.getNowTime();
      }
      this.searchdata();
    },
  },
}
</script>

<style lang="less" scoped>
/* ===== 能耗总览 — 参考 /console/energy/overview 样式 ===== */
.energy-overview {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* ===== 顶部统计卡片 ===== */
.stat-cards {
  display: flex;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 1px 2px rgba(0,0,0,0.06);
  overflow: hidden;
}

.stat-card-group {
  flex: 1;
  padding: 20px 24px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.stat-divider {
  width: 1px;
  background: #f0f0f0;
  flex-shrink: 0;
}

.stat-card-main {
  display: flex;
  align-items: baseline;
  gap: 6px;
  flex-wrap: wrap;
}

.stat-label {
  font-size: 13px;
  color: #7D879F;
  width: 100%;
}

.stat-value {
  font-size: 28px;
  font-weight: 700;
  color: #252B3C;
  line-height: 1.2;
  letter-spacing: 0.5px;
}

.stat-unit {
  font-size: 13px;
  color: #7D879F;
}

.stat-card-sub {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.sub-row {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.sub-label {
  font-size: 12px;
  color: #7D879F;
}

.sub-value {
  font-size: 16px;
  font-weight: 600;
  color: #252B3C;
  letter-spacing: 0.3px;
}

.sub-unit {
  font-size: 12px;
  color: #7D879F;
}

.sub-compare {
  font-size: 12px;
  display: inline-flex;
  align-items: center;
  gap: 2px;
  &.trend-up { color: #D61E1E; }
  &.trend-down { color: #008B61; }
}

.trend-arrow {
  width: 12px;
  height: 12px;
  vertical-align: middle;
}

/* ===== 图表卡片 ===== */
.chart-card {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 1px 2px rgba(0,0,0,0.06);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.chart-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 20px;
  border-bottom: 1px solid #f0f0f0;
  flex-wrap: wrap;
  gap: 8px;
}

.chart-title {
  font-size: 15px;
  font-weight: 600;
  color: #252B3C;
  flex-shrink: 0;
}

.chart-tabs {
  display: flex;
  gap: 0;
  align-items: center;
}

.tab-btn {
  font-size: 13px;
  color: #7D879F;
  cursor: pointer;
  padding: 4px 12px;
  border-bottom: 2px solid transparent;
  transition: color 0.2s, border-color 0.2s;
  &:hover { color: #2A62FF; }
  &.tab-active {
    color: #2A62FF;
    border-bottom-color: #2A62FF;
    font-weight: 500;
  }
}

.chart-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.ov-date-picker {
  width: 140px;
  :deep(.el-input__inner) {
    padding-left: 8px;
  }
  :deep(.el-input__prefix) {
    left: auto;
    right: 8px;
  }
}

.chart-body {
  flex: 1;
  padding: 16px;
  display: flex;
  min-height: 0;
}

.cav-chart {
  width: 100%;
  height: 320px;
}
</style>
